import set from 'lodash/set';
import state from 'store/state/zone';
import types from 'store/types/zone';

const initialState = state;

export default (state = initialState, action) => {
  const { key, data, error } = action;

  switch (action.type) {
    case types.ZONE_SET:
      set(state, key, data);
      return { ...state };
    default:
      return state;
  }
};
